
<div style="margin-left: auto; margin-right: auto; margin-top:0.5rem;">
  <slot />
</div>

